import {Request} from '../request';

import {handleError} from './error-handler';

export interface Query {
    conditions?: Record<string, unknown> | Array<Record<string, unknown>>;
    populate?: string[];
    fields?: string[];
    limit?: number;
    offset?: number;

    [p: string]: unknown;
}

export const request = new Request(process.env.REACT_APP_API_URL as string, {
    credentials: true,
    onError: handleError,
});

export class Agent<T> {
    private readonly Resource: new (x?: T) => T;
    private readonly endpoint: string;

    constructor(Resource: new (x?: T) => T, endpoint: string) {
        this.Resource = Resource;
        this.endpoint = endpoint;
    }

    getAll = async (query?: Query) => {
        const res = await request.get(this.endpoint, query);
        return res.map((el: T) => new this.Resource(el)) as T[];
    };

    getById = async (id: number | string, query?: Query) => {
        const res = await request.get(`${this.endpoint}/${id}`, query);
        return new this.Resource(res) as T;
    };

    create = async (data: T) => {
        const res = await request.post(this.endpoint, data as {});
        return new this.Resource(res) as T;
    };

    updateOne = async (id: number | string, data: T) => {
        const res = await request.put(`${this.endpoint}/${id}`, data as {});
        return new this.Resource(res) as T;
    };

    updateMany = async (data: T[]) => {
        const res = await request.put(this.endpoint, data);
        return res.map((el: T) => new this.Resource(el)) as T[];
    };

    del = async (id: number | string) => {
        await request.del(`${this.endpoint}/${id}`);
    };
}